import coverSrc from 'assets/img/generic/4.jpg';
import { useAuth } from 'context/AuthContext';
import { getUserProfileData } from 'helpers/userProfile';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ProfileBanner from '../ProfileBanner';
import AccountSettings from './AccountSettings';
import ChangePassword from './ChangePassword';
import ProfileSettings from './ProfileSettings';

const Settings = () => {
  const { t } = useTranslation();
  const { userData } = useAuth();
  const { initials } = getUserProfileData(userData);

  return (
    <>
      <ProfileBanner>
        <ProfileBanner.Header
          coverSrc={coverSrc}
          avatarName={initials}
          className="mb-8"
        />
        <ProfileBanner.Body>
          <h4 className="mb-1">{t('USER_SETTINGS.PAGE_TITLE')}</h4>
          <p className="text-600 mb-0">{t('USER_SETTINGS.PAGE_DESCRIPTION')}</p>
        </ProfileBanner.Body>
      </ProfileBanner>
      <Row className="g-3">
        <Col lg={8}>
          <ProfileSettings />
        </Col>
        <Col lg={4}>
          <div className="sticky-sidebar">
            <AccountSettings />
            <ChangePassword />
          </div>
        </Col>
      </Row>
    </>
  );
};

export default Settings;
